import { Button } from 'shared-ui';

import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';

import { DeleteMultiGroupAssignedOwnersProps } from './DeleteMultiGroupAssignedOwners.types';

export const DeleteMultiGroupAssignedOwners = ({
  checkedOwners,
  isModalOpen,
  onSubmit,
  isLoading,
  onModalClose,
  onModalOpen,
}: DeleteMultiGroupAssignedOwnersProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        size="medium"
        startIcon={<TrashIcon style={{ opacity: !perms?.UPR_GRUPOWE?.edit ? 0.4 : 1 }} />}
        onClick={onModalOpen}
        disabled={!perms?.UPR_GRUPOWE?.edit}
      >
        {formatMessage({ id: AppMessages['cards.multiAction.delete.button'] })}
      </Button>

      <ActionModal
        header={formatMessage({ id: AppMessages['owners.multiAction.delete.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['owners.multiAction.delete.submitButton'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['owners.multiAction.delete.subtitle'] })} {checkedOwners.length}
        </ActionModal.Subtitle>

        <ActionModal.Text>{formatMessage({ id: AppMessages['owners.multiAction.delete.group'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
